import React, { useState } from 'react';
import { Avatar, ActionIcon, Indicator, Notification } from '@mantine/core';
import { Bell } from 'tabler-icons-react';
import { motion } from 'framer-motion';
import { Link } from '@inertiajs/react';

// Use the User type from your UserContext instead of defining our own
interface UserSectionProps {
  user: any; // Using any to match your UserContext type - you can replace with your actual User interface
  onLogout?: () => void;
}

const UserSection: React.FC<UserSectionProps> = ({ user, onLogout }) => {
  const [showNotification, setShowNotification] = useState(false);
  const [notificationsCount] = useState(0); // Future feature

  const getLoginUrl = () => {
    const currentPath = window.location.pathname;
    return `/login?return_to=${encodeURIComponent(currentPath)}`;
  };

  const handleBellClick = () => {
    setShowNotification(true);
    setTimeout(() => {
      setShowNotification(false);
    }, 5000);
  };

  const getDefaultAvatarUrl = () => {
    return 'https://dancewise.s3.amazonaws.com/WCWD+blank+profile2.png';
  };

  if (!user) {
    return (
      <a href={getLoginUrl()} className="nav-link ms-2">
        Log in
      </a>
    );
  }

  return (
    <div className="navy-left flex items-center ml-auto">
      {/* Notification Bell - Currently commented out but ready for future use */}
      {/* <div className="notification-bell-container">
        <Indicator
          size={notificationsCount > 0 ? 16 : 8}
          color="orange"
          processing={notificationsCount > 0}
          offset={3}
        >
          <motion.div whileTap={{ scale: 0.9 }} whileHover={{ rotate: [0, -5, 5, 0] }}>
            <ActionIcon
              size="lg"
              variant="transparent"
              onClick={handleBellClick}
              className="notification-bell"
            >
              <Bell strokeWidth={1.75} color="gray" style={{ width: '30px', height: '30px' }} />
            </ActionIcon>
          </motion.div>
        </Indicator>
      </div> */}

      {/* Notification Popup */}
      {showNotification && (
        <div className="absolute top-14 right-14 z-50">
          <Notification
            title="Coming Soon!"
            color="orange"
            withCloseButton={true}
            onClose={() => setShowNotification(false)}
          >
            Notifications will be available in a future update!
          </Notification>
        </div>
      )}

      {/* Mobile Avatar */}
      <div className="mobile-avatar">
        <Link href={`/users/${user.username}/user-settings`} className="" style={{}}>
          <Avatar src={user.avatar_url || undefined} />
        </Link>
      </div>

      {/* Desktop User Profile */}
      <div className="user-profile">
        <Link href={`/users/${user.username}/user-settings`} className="user-navbutton flex items-center" style={{}}>
          {user.avatar_url ? (
            <img src={user.avatar_url} className="img-circle avatar_small mr-2" alt="Avatar" />
          ) : (
            <img src={getDefaultAvatarUrl()} className="img-circle avatar_small" alt="Default avatar" />
          )}
          <div className="username-nav poppins">{user.username}</div>
        </Link>
      </div>
    </div>
  );
};

export default UserSection;
